<template>
    <v-card-actions>
        <span style="font-size: 12px; font-weight: 700; color: #606263; padding-left: 10px;">Status: Chosen Flight on: {{ get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord | dayjsFormatDate2 }}&nbsp;&nbsp;&nbsp;New selected Date on: {{ get_flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker | dayjsFormatDate2 }}</span>
        <v-spacer></v-spacer>
        <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet">Close</v-btn>
    </v-card-actions>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';


    export default {
        name: 'ActionBar',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'create', 'update'
            editorFlightLegMode: String, // 'single', 'rotation'
            activeStepper: String, // Active Stepper

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_ResourceDetails_ResourceAskedFor_Date_EventRecord',
                'get_flights_ResourceDetails_ResourceAskedFor_Date_BriefPicker',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_reset_ResourceAskedFor_Date_BriefPicker'
            ]),


            /*******************************************************************
            * Listeners: Common
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                let  me = this;


				me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/ActionBAr.vue >>> onClick_CloseSheet');
                me.$emit('close');

                this.actn_reset_ResourceAskedFor_Date_BriefPicker(); // reset

            }, // eo function onClick_CloseSheet()

        }, // eo methods{}
    };
</script>

<style scoped>
    .sdr-disabled {
        background-color: rgba(0, 0, 0, 0.12) !important;
        color: rgba(0, 0, 0, 0.26) !important;
    }
</style>